import { Component } from './Component';
import { Header } from './Header';

/**
 * Component for handling DeleteSend action.
 */
export class DeleteSend extends Component {
  /**
   * Render template.
   *
   * @param {object} opts - The options to render in the component.
   */
  render(opts) {
    Header.deleteBackButton();
    super.render(opts);
    super.announceNextPageLoad();
  }
}
